var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "medal-type" }, [
      _c("img", { attrs: { src: require("@/assets/img/アセット 72@3x.png") } }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeHomeTown,
              expression: "activeHomeTown"
            }
          ]
        },
        [
          _c("div", { staticClass: "gold-medal-count position-Adjustment" }, [
            _vm._v(_vm._s(_vm.goldMedalCount) + " 個")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "silver-medal-count position-Adjustment" }, [
            _vm._v(_vm._s(_vm.silverMedalCount) + " 個")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "copper-medal-count position-Adjustment" }, [
            _vm._v(_vm._s(_vm.copperMedalCount) + " 個")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTeapicking,
              expression: "activeTeapicking"
            }
          ]
        },
        [
          _c("div", { staticClass: "gold-medal-count position-Adjustment" }, [
            _vm._v(_vm._s(_vm.goldMedalCountTea) + " 個")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "silver-medal-count position-Adjustment" }, [
            _vm._v(_vm._s(_vm.silverMedalCountTea) + " 個")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "copper-medal-count position-Adjustment" }, [
            _vm._v(_vm._s(_vm.copperMedalCountTea) + " 個")
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "medal-histry" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeHomeTown,
              expression: "activeHomeTown"
            }
          ],
          attrs: { id: "medal-type-itemsHome" }
        },
        [
          _c(
            "ul",
            { staticClass: "medal-items" },
            _vm._l(_vm.medalList, function(item) {
              return _c(
                "li",
                { key: item.id, staticClass: "medal-item-type" },
                [
                  _c("img", { attrs: { src: item.image } }),
                  _vm._v(" "),
                  _c("p", { style: item.color_style }, [
                    _c("span", { staticClass: "month" }, [
                      _vm._v(_vm._s(_vm._f("moment")(item.created_at, "MM")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "day" }, [
                      _vm._v(_vm._s(_vm._f("moment")(item.created_at, "DD")))
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTeapicking,
              expression: "activeTeapicking"
            }
          ],
          attrs: { id: "medal-type-itemsTea" }
        },
        [
          _c(
            "ul",
            { staticClass: "medal-items" },
            _vm._l(_vm.medalListTea, function(item) {
              return _c(
                "li",
                { key: item.id, staticClass: "medal-item-type" },
                [
                  _c("img", { attrs: { src: item.image } }),
                  _vm._v(" "),
                  _c("p", { style: item.color_style }, [
                    _c("span", { staticClass: "month" }, [
                      _vm._v(_vm._s(_vm._f("moment")(item.created_at, "MM")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "day" }, [
                      _vm._v(_vm._s(_vm._f("moment")(item.created_at, "DD")))
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeHomeTown,
            expression: "activeHomeTown"
          }
        ],
        attrs: { src: require("@/assets/img/アセット 73@3x.png") }
      }),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTeapicking,
            expression: "activeTeapicking"
          }
        ],
        attrs: { src: require("@/assets/img/アセット 79@3x.png") }
      }),
      _vm._v(" "),
      _c("p", {
        staticClass: "show-active-home",
        on: { click: _vm.showHomeTown }
      }),
      _vm._v(" "),
      _c("p", {
        staticClass: "show-active-tea",
        on: { click: _vm.showTeapicking }
      })
    ]),
    _vm._v(" "),
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isActiveUp,
          expression: "isActiveUp"
        }
      ],
      staticClass: "up-arrow",
      attrs: { src: require("@/assets/img/アセット 77@3x.png") },
      on: { click: _vm.pushUp }
    }),
    _vm._v(" "),
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isActiveDown,
          expression: "isActiveDown"
        }
      ],
      staticClass: "down-arrow",
      attrs: { src: require("@/assets/img/アセット 78@3x.png") },
      on: { click: _vm.pushDown }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6e154c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6e154c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/History.vue
// module id = null
// module chunks = 